export default __webpack_public_path__ + "static/media/india.582af02c.svg";